class ShopTheLook {
  constructor(container) {
    this.container = container;
    this.form = container.querySelector('[data-look-form]');
    this.error = container.querySelector('[data-look-error]');
    this.submitButton = container.querySelector('[data-look-submit]');
    this.totalElement = container.querySelector('[data-look-total]');

    const json = container.querySelector(
      '[data-look-products]'
    );

    if (!this.form || !json) return;

    this.products = JSON.parse(json.textContent);

    this.bindEvents();
    this.updateTotal();
  }

  getSelectedVariantInput(row) {
  return (
    row.querySelector(
      'input[type="radio"][data-look-variant]:checked'
    ) ||
    row.querySelector(
      'input[type="hidden"][data-look-variant]'
    )
  );
}

  bindEvents() {
    this.form.addEventListener('change', () => {
      this.updateTotal();
      this.clearError();
    });

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();

      this.addLookToCart();
    });
  }

  getSelectedItems() {
    const rows = this.form.querySelectorAll('[data-look-item]');
    const items = [];
    const missing = [];

    rows.forEach((row) => {
      const include = row.querySelector('[data-look-include]');

      if (!include || !include.checked) return;

      const variantInput = this.getSelectedVariantInput(row);

      const variantId = Number(variantInput?.value);

      if (!variantId) {
        missing.push(
          row.dataset.productTitle || 'product'
        );
        return;
      }

      items.push({
        id: variantId,
        quantity: 1
      });
    });

    return { items, missing };
  }

  updateTotal() {
    let total = 0;

    const rows = this.form.querySelectorAll('[data-look-item]');

    rows.forEach((row) => {
      const include = row.querySelector('[data-look-include]');

      if (!include || !include.checked) return;

      const variantInput = this.getSelectedVariantInput(row);

      const variantId = Number(variantInput?.value);

      if (!variantId) return;

      this.products.forEach((product) => {
        const variant = product.variants.find(
          (variant) =>
            Number(variant.id) === variantId
        );

        if (variant) {
          total += Number(variant.price);
        }
      });
    });

    this.totalElement.textContent =
      this.formatMoney(total);
  }

  formatMoney(cents) {
    if (
      window.theme &&
      theme.Currency &&
      typeof theme.Currency.formatMoney === 'function' &&
      theme.settings &&
      theme.settings.moneyFormat
    ) {
      return theme.Currency.formatMoney(
        cents,
        theme.settings.moneyFormat
      );
    }

    return new Intl.NumberFormat('nl-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  async addLookToCart() {
    const { items, missing } = this.getSelectedItems();

    if (missing.length) {
      this.showError(
        `Kies eerst een maat voor: ${missing.join(', ')}.`
      );
      return;
    }

    if (!items.length) {
      this.showError('Selecteer minstens één item.');
      return;
    }

    this.submitButton.disabled = true;

    const oldText = this.submitButton.textContent;
    this.submitButton.textContent = 'Toevoegen…';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'De look kon niet worden toegevoegd.'
        );
      }

      /*
       * Impulse officieel laten weten
       * dat de cart opnieuw opgebouwd moet worden.
       */
      document.dispatchEvent(
        new CustomEvent('cart:build')
      );

      /*
       * Wacht even tot Impulse de cart heeft bijgewerkt
       * en open daarna de bestaande drawer.
       */
      setTimeout(() => {
        const cartButton =
          document.querySelector('.js-drawer-open-cart') ||
          document.querySelector('.cart-link');

        if (cartButton) {
          cartButton.click();
        }
      }, 400);

    } catch (error) {
      console.error('Shop the look error:', error);
      this.showError(error.message);
    } finally {
      this.submitButton.disabled = false;
      this.submitButton.textContent = oldText;
    }
  }

  showError(message) {
    if (!this.error) return;

    this.error.hidden = false;
    this.error.textContent = message;
  }

  clearError() {
    if (!this.error) return;

    this.error.hidden = true;
    this.error.textContent = '';
  }
}

function initShopTheLook() {
  document
    .querySelectorAll('[data-look-page]')
    .forEach((container) => {
      if (container.dataset.lookInitialized === 'true') return;

      container.dataset.lookInitialized = 'true';

      new ShopTheLook(container);
    });
}

document.addEventListener('DOMContentLoaded', initShopTheLook);

/*
 * Impulse gebruikt ook page:loaded.
 */
document.addEventListener('page:loaded', initShopTheLook);

class ImpulseLookGallery {

  constructor(container) {
    this.container = container;

    this.mainSlider = container.querySelector(
      '[data-product-photos]'
    );

    this.thumbSlider = container.querySelector(
      '[data-product-thumbs]'
    );

    this.thumbScroller = container.querySelector(
      '.product__thumbs--scroller'
    );

    this.imageContainer = container.querySelector(
      '[data-product-images]'
    );

    if (!this.mainSlider) return;

    this.initSlider();
    this.initZoom();
  }


  initSlider() {

    const slides = this.mainSlider.querySelectorAll(
      '.product-main-slide'
    );

    if (slides.length <= 1) {

      if (slides[0]) {
        slides[0].classList.add('is-selected');
      }

      return;
    }

    this.flickity = new theme.Slideshow(
      this.mainSlider,
      {
        dragThreshold: 25,

        adaptiveHeight: true,

        avoidReflow: true,

        initialIndex: 0,

        childNav: this.thumbSlider,

        childNavScroller: this.thumbScroller,

        childVertical: true,

        /*
         * Dit gebruikt Impulse zelf.
         * Desktop verbergt deze via CSS,
         * mobiel worden de dots gebruikt.
         */
        pageDots: true,

        wrapAround: true
      }
    );
  }


  initZoom() {

    if (!this.imageContainer) return;

    this.photoswipe = new theme.Photoswipe(
      this.imageContainer,
      this.container.dataset.sectionId || 'look'
    );

    this.imageContainer.addEventListener(
      'photoswipe:afterChange',
      (event) => {

        if (this.flickity) {
          this.flickity.goToSlide(
            event.detail.index
          );
        }

      }
    );
  }
}

function initImpulseLookGalleries() {

  document
    .querySelectorAll('[data-look-gallery-native]')
    .forEach((container) => {

      if (
        container.dataset.impulseGalleryInitialized === 'true'
      ) {
        return;
      }

      container.dataset.impulseGalleryInitialized = 'true';

      new ImpulseLookGallery(container);

    });
}


document.addEventListener(
  'DOMContentLoaded',
  initImpulseLookGalleries
);

document.addEventListener(
  'page:loaded',
  initImpulseLookGalleries
);